import { createFileRoute } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { PasswordReset } from '../components/PasswordReset';
import { getAuthStore } from '../main';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/password-reset')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
  },
  component: ResetForm,
});

function ResetForm() {
  const { token, id } = Route.useSearch();

  return (
    <>
      <AccountHeader />
      <div className="app">
        <div style={{ gridArea: 'main / sidebar / main / main' }}>
          <Pane classes={'sp-register sp-login'} tag="main">
            <PasswordReset token={token} id={id} />
          </Pane>
        </div>
      </div>
    </>
  );
}
